import { Component, OnInit, Input, ViewEncapsulation, ElementRef, Renderer2, ViewChild, Inject } from '@angular/core';
import { AdssService, AppSettingsService, FilesService } from './../../../services';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

declare var $;

@Component({
  selector: 'widget-rek',
  templateUrl: './adss.component.html',
  styleUrls: ['./adss.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class AdssComponent implements OnInit {

  constructor(
    private _ads: AdssService,
    private _sanitizer: DomSanitizer,
    // private _files: FilesService,
    // private _appSettings: AppSettingsService
    private readonly elementRef: ElementRef,
    private renderer: Renderer2,
  ) { }

  @Input() type: string;
  @Input() mobile: boolean;
  baseUrlPhoto = AppSettingsService.API_ENDPOINT_PHOTOSTORE;
  result;
  onlyHtml: SafeHtml;

  getTrueText(html) {
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  getItem() {
    this._ads.get(this.type || 'prim_a').subscribe(
      async res => {
        // console.log(this.type, res);
        this.result = res;
        // console.log(this.result);
        // let urls = [
        //   'https://s0.2mdn.net/ads/studio/cached_libs/tweenmax_1.18.0_499ba64a23378545748ff12d372e59e9_min.js',
        //   'https://s0.2mdn.net/ads/studio/cached_libs/easeljs_1.0.0_min.js',
        //   'https://s0.2mdn.net/ads/studio/cached_libs/createjs_2019.11.15_min.js',
        //   // 'assets/customad/index_240x400_google.js'
        // ];
        if (this.result && this.result[0] && this.result[0].isHtml == 1) {
          console.log(this.result);
          if (this.result[0] && this.result[0].urlsHtml.length != "") {
            let urls = this.result[0].urlsHtml.split('\n\n').map(v=>v.split('\n'));
            // const recursiveCall = (index) => {
            //   return new Promise((resolve) => {
            //     console.log(index);
            //     if (index < urls.length) {
            //       Promise.all(urls[index].map(v=>this.importScripts(v))).then(
            //         res => {
            //           // $(this.result.textHtml).appendTo($('#customInsertConent'));
            //           return resolve(recursiveCall(++index))
            //         },
            //         err => {}
            //       )
                  
            //     } else {
            //       return resolve(true);
            //     }
            //   })
            // }
          
            // recursiveCall(0).then(() => $(this.result.textHtml).appendTo($('#customInsertConent')));
            


            Promise.all(urls[0].map(v=>this.importScripts(v))).then(
              res => {
                // console.log('Promise ALL', res);
                Promise.all(urls[1].map(v=>this.importScripts(v))).then(
                  res => {
                    $(this.result[0].textHtml).appendTo($('#customInsertConent-'+this.type));      
                  },
                  err => {}
                )
              },
              err => {}
            );
          } else {
            // $(this.result.textHtml).appendTo($('#customInsertConent'));
            this.onlyHtml = this._sanitizer.bypassSecurityTrustHtml(this.result[0].textHtml);
          }
        }
      },
      err => {}
    );
  }

  importScripts(url) {
    return new Promise((resolve, reject) => {
      const script = this.renderer.createElement('script');
      script.src = url;
      script.onload = () => {
        resolve(true);
      };
     
      // $.getScript(url, () => {
      //   // alert("Running test.js");
      //   resolve(true);
      // });

      this.renderer.insertBefore(this.elementRef.nativeElement, script, this.elementRef.nativeElement.firstChild);
    });
  }

  ngAfterViewInit() {
    
  }

  ngOnInit() {
    this.getItem();
  }

}
